import { StyleSheet, Platform } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  users: {
    flex: 1,
  },
  maximumHeight: {
    maxHeight: 100,
  },
  iconTextContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
    padding: 0,
  },
  textContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  setCardOptions: {
    marginTop: 10,
  },
  setCardOptionWrapper: {
    flex: 1,
    padding: 8,
  },
  setCardOption: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardOptionName: {
    color: colors.darkGrey,
    fontSize: 14,
    fontWeight: '500',
  },
  switchSize: {
    transform: [{ scale: Platform.OS == 'android' ? 1 : 0.85 }],
  },

  topBorder: {
    borderTopWidth: 2,
    borderTopColor: colors.lightGrey,
  },
});
